module.exports = __webpack_public_path__ + "assets/e19fd980efaa7124380c485efe26e7c1.mp3";